import type { CSSProperties } from 'react';
import { AsaroOrb, type OrbMode } from './AsaroOrb';

interface WordmarkProps {
  mode?: OrbMode;
  className?: string;
  style?: CSSProperties;
}

export function Wordmark({ mode = 'tone', className, style }: WordmarkProps) {
  const cls = `wm${mode === 'ink-light' ? ' ink-light' : ''}${className ? ' ' + className : ''}`;
  return (
    <span className={cls} style={style}>
      <span className="lt">Crani</span>
      <AsaroOrb mode={mode} />
    </span>
  );
}
